export const REPEAT_ORDER= 'REPEAT_ORDER'
export const REPEAT_ORDER_SUCCESS= 'REPEAT_ORDER_SUCCESS'
export const REPEAT_ORDER_ERROR='REPEAT_ORDER_ERROR'

export const RepeatOrder= (data) => ({
    type: REPEAT_ORDER,
    payload: data
})